import React from 'react';
import { Button, Notification } from '@codeparva/ui-components-library';
import { changePasswordFormSchema } from '../../formValidationSchema';
import { Form, Formik } from 'formik';
import { AccountSettingsTypes } from '../../AccountSettingsTypes';
import { MyPasswordField } from './AccountSettingFormFeilds';
export const UpdatePasswordForm = ({
  AccountPasswordUpdate,
}: AccountSettingsTypes.TUpdateAccountPassword) => {
  const [notificationPassword, setPasswordNotification] = React.useState(false);
  return (
    <>
      <Formik
        initialValues={{
          oldPassword: '',
          newPassword: '',
          confirmPassword: '',
        }}
        validationSchema={changePasswordFormSchema}
        onSubmit={(values, { resetForm }) => {
          AccountPasswordUpdate(values, setPasswordNotification);
          resetForm();
        }}
      >
        {({ dirty, isValid }) => (
          <div className="accountPasswordForm">
            <div className="cardInfoContainer">
              <Form>
                <div className="cardNumberSection">
                  {notificationPassword ? (
                    <div className="notificationSection">
                      <Notification className="notificationColor">
                        Password has been updated successfully
                        <button
                          className="delete"
                          onClick={() => setPasswordNotification(false)}
                        ></button>
                      </Notification>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="cardInputContainer">
                    <MyPasswordField
                      label="Old Password"
                      name="oldPassword"
                      placeholder="Enter Old Password"
                    />
                  </div>
                  <div className="cardInputContainer">
                    <MyPasswordField
                      label="New Password"
                      name="newPassword"
                      placeholder="Enter New Password"
                    />
                  </div>
                  <div className="cardInputContainer">
                    <MyPasswordField
                      label="Confirm Password"
                      name="confirmPassword"
                      placeholder="Enter Confirm Password"
                    />
                  </div>
                </div>
                <div className="btnContainer">
                  <Button
                    className="cp-primary-button-highlighted"
                    type="submit"
                    disabled={!dirty || !isValid}
                  >
                    Update Details
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};
